/**
 * `time_tracking` → **Customize Time tracking column** — rebuilt 1:1 from the capture
 * (`discovery/ui-reference/editors/time_tracking/dialog-settings.{png,json}`).
 *
 * The whole dialog, measured: a 320 × **121** card, the title *Time Tracking column settings*,
 * the section label **Time presentation** (114 × 21) and a single checkbox **Show seconds**
 * (115 × 20). That is monday's entire configuration for the type, and `showSeconds` is the one
 * key `timeTrackingSettingsSchema` carries beside `hide_footer` (spec M2 tier-2 §5.7).
 *
 * The four timer verbs (`start` / `stop` / `addSession` / `deleteSession`) are cell actions, not
 * settings, and live in the cell's panel.
 */
import type { TimeTrackingSettings } from '@elizmonday/shared';
import {
  HideSummaryField,
  SettingsCheckbox,
  SettingsSection,
  SettingsForm,
  useSettingsDraft,
} from '../settings-kit';
import type { ColumnSettingsProps } from '../types';

export function TimeTrackingSettingsDialog({
  settings,
  onCommit,
  onCancel,
}: ColumnSettingsProps<TimeTrackingSettings>) {
  const [draft, patch] = useSettingsDraft<TimeTrackingSettings>(settings);
  return (
    <SettingsForm
      title="Time Tracking column settings"
      testId="time-tracking-settings"
      onSave={() => onCommit(draft)}
      onCancel={onCancel}
    >
      <SettingsSection label="Time presentation" />
      <SettingsCheckbox
        label="Show seconds"
        testId="time-tracking-seconds"
        checked={draft.showSeconds ?? false}
        onChange={(next) => patch({ showSeconds: next })}
      />
      <HideSummaryField
        testId="time-tracking-hide-footer"
        checked={draft.hide_footer ?? false}
        onChange={(next) => patch({ hide_footer: next })}
      />
    </SettingsForm>
  );
}
